import { useCallback, useEffect, useState } from 'react';

export interface ServiceWorkerUpdateResult {
  updateAvailable: boolean;
  applyUpdate: () => void;
}

function getServiceWorker(): ServiceWorkerContainer | null {
  if (!('serviceWorker' in navigator)) return null;
  const sw = navigator.serviceWorker;
  return sw ?? null;
}

export function useServiceWorkerUpdate(): ServiceWorkerUpdateResult {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    const sw = getServiceWorker();
    if (!sw) return;
    const handleControllerChange = () => setUpdateAvailable(true);
    sw.addEventListener('controllerchange', handleControllerChange);
    return () => sw.removeEventListener('controllerchange', handleControllerChange);
  }, []);

  const applyUpdate = useCallback(() => {
    window.location.reload();
  }, []);

  if (!getServiceWorker()) {
    return { updateAvailable: false, applyUpdate: () => {} };
  }

  return { updateAvailable, applyUpdate };
}
